import List from '@/components/common/List';
import { useApplication } from '@/hooks/useApplication';
import { useMetadataBlock } from '@/hooks/useMetadataBlock';
import { useUpdateNodes } from '@/hooks/useUpdateNodes';
import { EventHandler } from '@/types/eventhandler';
import { FC } from 'react';
import EventHandlerView from './events/EventHandlerView';

type EventsViewProps = {
  id: number;
  parentId: number;
};

const EventsView: FC<EventsViewProps> = (props) => {
  const { application, setApplication } = useApplication();
  const { setUpdateNodes } = useUpdateNodes();
  const { metadataBlock } = useMetadataBlock();
  if (!metadataBlock || !metadataBlock.event_handlers) return <></>;

  const eventHandlers = application.blocks.event_handlers?.[props.id] ?? {};

  return (
    <List>
      {metadataBlock.event_handlers.map((eventHandle, index) => {
        return (
          <EventHandlerView
            key={`EventHandlerView.${eventHandle.name}.${index}`}
            nodeId={props.id}
            parentId={props.parentId}
            metaEventHandler={eventHandle}
            data={eventHandlers[eventHandle.name]}
            onChange={(...args) => {
              setApplication((previous) => {
                const handlers = previous.blocks.event_handlers ?? {};
                const nodeHandlers = handlers[props.id] ?? {};
                // -1 only survives when the args below carry no eventstart of their own.
                const event: EventHandler = {
                  ...(nodeHandlers[eventHandle.name] ?? { eventstart: -1, arguments: [] })
                };
                args.forEach(([configValue, newValue]) => {
                  (event as Record<string, unknown>)[configValue] = newValue;
                });

                return {
                  ...previous,
                  blocks: {
                    ...previous.blocks,
                    event_handlers: {
                      ...handlers,
                      [props.id]: { ...nodeHandlers, [eventHandle.name]: event }
                    }
                  }
                };
              });
              setUpdateNodes([props.id.toString()]);
            }}
          />
        );
      })}
    </List>
  );
};

export default EventsView;
